<template>
  <div class="selected-options-product selected-options-product__color">
    <div class="color-list">
      <div class="swatch-option active">
        <div class="swatch-option__radio" :style="styleComp" @click.prevent="change(sibiling)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  computed: {
    styleComp () {
      return `background: ${this.option.color_type === '1' ? this.option.color_value : `center / contain no-repeat url(${this.option.color_image})`}`
    }
  }
}
</script>
